/*jshint esversion: 11 */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge
} from 'reactstrap';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import { getBadgeInfo, getBadgeList } from '../../api/badge';
import moment from 'moment';
import CreateBadgeModal from './CreateBadgeModal';
import ViewBadgeModal from './ViewBadgeModal';
import UpdateBadgeModal from './UpdateBadgeModal';
import { validatePermissionKey } from '../../helpers/permission';
import { CREATE_BADGE, DELETE_BADGE, UPDATE_BADGE } from '../Utility/PermissionKeys';
import validator from 'validator';
import { stringify as QStringify, parse as QParse } from 'qs';
import { useHistory } from 'react-router-dom';
import BadgesFilterModal from './BadgesFilterModal';
import DeleteBadgeModal from './DeleteTagModal';
// import { getBadgeList } from '../../api/badge';

const BadgeListPage = ({ authUser }) => {
  const history = useHistory();
  const [filterError, setFilterError] = useState(false);
  const [breadcrumbItems] = useState([
    { title: 'Badges', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [badgeListLoading, setBadgeListLoading] = useState(true);
  const [badgeList, setBadgeList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [addBadgeModalOpen, setAddBadgeModalOpen] = useState(false);
  const [badgeInfo, setBadgeInfo] = useState({});
  const [badgeInfoLoading, setBadgeInfoLoading] = useState(false);
  const [badgeInfoModalOpen, setBadgeInfoModalOpen] = useState(false);
  const [updateBadgeModalOpen, setUpdateBadgeModalOpen] = useState(false);
  const [sortingRule, setSortingRule] = useState('name$asc');
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [createdAtFilter, setCreatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [updatedAtFilter, setUpdatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [filterBadgeName, setFilterBadgeName] = useState('');
  const [deleteBadgeModalOpen, setDeleteBadgeModalOpen] = useState(false);
  const [badgeId, setBadgeId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);

  let listElem = document.getElementById('badgeList');
  let linkElem = document.getElementById('badgeLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    if (authUser) {
      populateSearchOptions(history?.location?.search);
    }
    // eslint-disable-next-line
  }, [authUser, listElem, linkElem]);

  const handlePagination = (page) => {
    fetchData(page, pagination.pageLimit, createQueryOptions(), sortingRule);
  };

  const fetchData = async (
    current_page = 1,
    page_limit = 10,
    queryOptions = {},
    sortingOption = sortingRule
  ) => {
    setBadgeListLoading(true);
    const response = await getBadgeList(
      current_page,
      page_limit,
      queryOptions,
      sortingOption
    );

    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setBadgeList(response.data);
      setBadgeListLoading(false);
    }
  };

  /**
   *
   * @param {string} str
   */
  function getValidDateInput(str) {
    return validator.isDate(str) ? new Date(str).toISOString() : '';
  }

  function createQueryOptions(
    createdStart = createdAtFilter.startDate,
    createdEnd = createdAtFilter.endDate,
    updatedStart = updatedAtFilter.startDate,
    updatedEnd = updatedAtFilter.endDate,
    name = filterBadgeName,
    deletedStatus = isDeleted
  ) {
    setFilterError(false);
    if (
      (!createdStart && createdEnd) ||
      (createdStart && !createdEnd) ||
      (!updatedStart && updatedEnd) ||
      (updatedStart && !updatedEnd)
    ) {
      setFilterError('Enter valid date range');
      return;
    }
    const startDateISOStringCreatedAt = getValidDateInput(createdStart);
    const endDateISOStringCreatedAt = getValidDateInput(createdEnd);
    const startDateISOStringUpdatedAt = getValidDateInput(updatedStart);
    const endDateISOStringUpdatedAt = getValidDateInput(updatedEnd);
    const queryOptions = {
      filter_start_created_at: startDateISOStringCreatedAt,
      filter_end_created_at: endDateISOStringCreatedAt,
      filter_start_last_updated_at: startDateISOStringUpdatedAt,
      filter_end_last_updated_at: endDateISOStringUpdatedAt,
      name,
      include_deleted: deletedStatus,
      sorting_option: sortingRule
    };
    updateUrlPath(queryOptions);
    return queryOptions;
  }

  function updateFilterCount(option) {
    let count = 0;
    Object.keys(option).forEach((i) => {
      if (option[i]?.toString()?.trim()?.length > 0 && option[i] !== false) {
        count += 1;
      }
    });
    setCurrentFilterCount(count - 1);
  }

  /**
   *
   * @param {string} searchQuery
   */
  function populateSearchOptions(searchQuery) {
    const parsedQuery = QParse(searchQuery.substring(1));
    if (
      parsedQuery.filter_start_created_at &&
      parsedQuery.filter_end_created_at
    ) {
      updateDateFilterInput(
        parsedQuery.filter_start_created_at,
        parsedQuery.filter_end_created_at,
        setCreatedAtFilter
      );
    }
    if (
      parsedQuery.filter_start_last_updated_at &&
      parsedQuery.filter_end_last_updated_at
    ) {
      updateDateFilterInput(
        parsedQuery.filter_start_last_updated_at,
        parsedQuery.filter_end_last_updated_at,
        setUpdatedAtFilter
      );
    }
    setFilterBadgeName(parsedQuery.name);
    const sortingOption = parsedQuery.sorting_option || sortingRule;
    setSortingRule(sortingOption);
    updateFilterCount(parsedQuery);
    fetchData(1, null, parsedQuery, sortingOption);
  }

  /**
   *
   * @param {string} str
   * @param {function} setHook
   * @returns
   */
  function updateDateFilterInput(startStr, endStr, setHook) {
    setHook({
      startDate: new Date(startStr),
      endDate: new Date(endStr)
    });
  }

  function updateUrlPath(queryOptions) {
    const queryString = QStringify(queryOptions);
    history.replace(`/badges?${queryString}`);
  }

  async function fetchSortedList(sortingOption) {
    setSortingRule(sortingOption);
    const queryOptions = createQueryOptions();
    queryOptions.sorting_option = sortingOption;
    updateUrlPath(queryOptions);
    fetchData(1, null, queryOptions, sortingOption);
  }

  function openFilterModal() {
    setFilterModalOpen(true);
  }

  function closeFilterModal() {
    setFilterModalOpen(false);
  }

  function openAddBadgeModal() {
    setAddBadgeModalOpen(true);
  }

  function closeAddBadgeModal() {
    setAddBadgeModalOpen(false);
  }

  function openBadgeInfoModal(roleId) {
    fetchBadgeInfo(roleId);
    setBadgeInfoModalOpen(true);
  }

  function closeBadgeInfoModal() {
    setBadgeInfoModalOpen(false);
  }

  async function openUpdateBadgeModal(badgeId) {
    fetchBadgeInfo(badgeId);
    setUpdateBadgeModalOpen(true);
  }

  function closeUpdateBadgeModal() {
    setUpdateBadgeModalOpen(false);
  }

  async function openDeleteBadgeModal(badgeId, requestType) {

    setBadgeId({
      badgeId,
      requestType
    });
    setDeleteBadgeModalOpen(true);
  }

  function closeDeleteBadgeModal() {
    setDeleteBadgeModalOpen(false);
  }

  async function fetchBadgeInfo(badgeId) {
    setBadgeInfoLoading(true);
    const response = await getBadgeInfo(badgeId);
    if (response) {
      setBadgeInfo(response);
      setBadgeInfoLoading(false);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <BadgesFilterModal
          filterError={filterError}
          setFilterError={setFilterError}
          modalOpenState={filterModalOpen}
          closeModalHandler={closeFilterModal}
          fetchList={fetchData}
          updateFilterCount={updateFilterCount}
          updateUrlPath={updateUrlPath}
          badgeName={filterBadgeName}
          setBadgeName={setFilterBadgeName}
          createdAtFilter={createdAtFilter}
          setCreatedAtFilter={setCreatedAtFilter}
          updatedAtFilter={updatedAtFilter}
          setUpdatedAtFilter={setUpdatedAtFilter}
          createQueryOptions={createQueryOptions}
          authUser={authUser}
          isDeleted={isDeleted}
          setIsDeleted={setIsDeleted}
        />
        <CreateBadgeModal
          modalOpenState={addBadgeModalOpen}
          closeModalHandler={closeAddBadgeModal}
          fetchNewBadgeList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
        />
        <ViewBadgeModal
          modalOpenState={badgeInfoModalOpen}
          closeModalHandler={closeBadgeInfoModal}
          badgeInfo={badgeInfo}
          badgeInfoLoading={badgeInfoLoading}
        />
        <UpdateBadgeModal
          modalOpenState={updateBadgeModalOpen}
          closeModalHandler={closeUpdateBadgeModal}
          badgeInfo={badgeInfo}
          badgeInfoLoading={badgeInfoLoading}
          fetchNewBadgeList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
        />
        {badgeId && (
          <DeleteBadgeModal
            modalOpenState={deleteBadgeModalOpen}
            closeModalHandler={closeDeleteBadgeModal}
            badgeId={badgeId.badgeId}
            type={badgeId.requestType}
            fetchNewData={async () => {
              let options = await createQueryOptions();
              if (options) {
                await fetchData(1, null, options);
              }
            }}
          />
        )}
        <Container fluid>
          <Breadcrumbs title="View Badges" breadcrumbItems={breadcrumbItems} />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <>
                    <Row className="mt-2">
                      <Col md="2">
                        <FormGroup>
                          <Col md="12">
                            <Label className="col-form-label">
                              Show Entries
                            </Label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                fetchData(
                                  1,
                                  e.target.value,
                                  createQueryOptions(),
                                  sortingRule
                                );
                                setPagination({
                                  ...pagination,
                                  pageLimit: e.target.value
                                });
                              }}
                              value={pagination.pageLimit}
                              disabled={badgeListLoading}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <Label className="col-form-label">Sort Badges</Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              fetchSortedList(e.target.value);
                            }}
                            value={sortingRule}
                            disabled={badgeListLoading}
                          >
                            <option value="name$asc">Badge Name (A-Z)</option>
                            <option value="name$desc">Badge Name (Z-A)</option>
                            <option value="created_at$desc">
                              Create Time (Newest First)
                            </option>
                            <option value="created_at$asc">
                              Create Time (Oldest First)
                            </option>
                            <option value="updated_at$desc">
                              Update Time (Newest First)
                            </option>
                            <option value="updated_at$asc">
                              Update Time (Oldest First)
                            </option>
                          </select>
                        </FormGroup>
                      </Col>
                      <Col className="d-flex justify-content-end align-items-center">
                        <Button
                          size="sm"
                          color="primary"
                          className=" waves-effect waves-light mr-3"
                          onClick={openFilterModal}
                        >
                          <i className="ri-filter-fill align-middle mr-2"></i>
                          <span>Filter Badge</span>
                          {currentFilterCount > 0 && (
                            <Badge color="light" pill className="ml-2">
                              {currentFilterCount}
                            </Badge>
                          )}
                        </Button>
                        {validatePermissionKey(authUser, CREATE_BADGE) && (
                          <Button
                            size="sm"
                            color="success"
                            className=" waves-effect waves-light"
                            onClick={openAddBadgeModal}
                          >
                            <i className="ri-add-line align-middle mr-2"></i>
                            Add Badge
                          </Button>
                        )}
                      </Col>
                    </Row>
                    {badgeListLoading ? (
                      <div className="text-center">
                        <PageDataLoader />
                      </div>
                    ) : (
                      <div className="table-rep-plugin">
                        <div
                          className="table-responsive mb-0"
                          data-pattern="priority-columns"
                        >
                          <Table
                            id="tech-companies-1"
                            striped
                            bordered
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>SL. No</th>
                                <th>Badge</th>
                                <th>Created At</th>
                                <th>Last Updated At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {badgeList?.map((item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>
                                    <p style={{fontWeight:'bold',padding:0,margin:0}}>
                                    {item.name}
                                    </p>
                                    <p style={{padding:0,margin:0}}>
                                    {item.summary}
                                    </p>
                                    </td>
                                  <td>
                                    {moment(new Date(item.createdAt)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    {moment(new Date(item.updatedAt)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      className=" waves-effect waves-light mr-2 mb-2"
                                      onClick={() => {
                                        openBadgeInfoModal(item._id);
                                      }}
                                    >
                                      <i className="fas fa-eye mr-2"></i>
                                      View
                                    </Button>
                                    {validatePermissionKey(
                                      authUser,
                                      UPDATE_BADGE
                                    ) && (
                                      <Button
                                        size="sm"
                                        color="warning"
                                        className=" waves-effect waves-light mr-2 mb-2"
                                        onClick={() => {
                                          openUpdateBadgeModal(item._id);
                                        }}
                                      >
                                        <i className="fas fa-edit mr-2"></i>
                                        Edit
                                      </Button>
                                    )}
                                    {validatePermissionKey(
                                      authUser,
                                      DELETE_BADGE
                                    ) && (
                                      <Button
                                        size="sm"
                                        color="danger"
                                        className=" waves-effect waves-light mb-2"
                                        onClick={() => {
                                      
                                          openDeleteBadgeModal(
                                            item?._id,
                                            item.isDeleted
                                              ? 'restore'
                                              : 'delete'
                                          );
                                        }}
                                      >
                                        {item.isDeleted ? (
                                          <i className="fas fa-trash-restore mr-2"></i>
                                        ) : (
                                          <i className="fas fa-trash mr-2"></i>
                                        )}
                                        {item.isDeleted ? 'Restore' : 'Delete'}
                                      </Button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                    <Row className="mt-2">
                      <Col md="5">
                        <p>
                          <strong>
                            {' '}
                            Showing{' '}
                            {(pagination.currentPage - 1) *
                              pagination.pageLimit +
                              1}{' '}
                            to{' '}
                            {Math.min(
                              pagination.currentPage * pagination.pageLimit,
                              pagination.totalEntries
                            )}{' '}
                            of {pagination.totalEntries} entries
                          </strong>
                        </p>
                      </Col>
                      {!badgeListLoading && badgeList.length > 0 && (
                        <Col md="7">
                          <Paginator
                            totalPages={pagination.totalPages}
                            currentPage={pagination.currentPage}
                            changePage={handlePagination}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(BadgeListPage);
